<div style="padding:20px;">
	<span class="float-end jmCloseBtn" (click)="close($event)"></span>
	<div *ngIf="pages.length > 0" style="margin:10px; padding-right:30px;" class="territoryCardTitleText">
		<div *ngIf="showBack">
			<button (click)="back2Cluster()" type="button" class="btn text-primary" style="padding: 0px; margin-right: 10px; font-size: 16px;">
				<i class="icnAngleLeft" style="font-weight: 900; font-size: 18px;"></i>&nbsp;
				<span>Back</span>
			</button>
		</div>
		<div *ngIf="normalizedData.tCardType === tCardType.FieldsOfStudy">
			Offered degrees in {{normalizedData.Name}}
		</div>
		<div *ngIf="normalizedData.tCardType !== tCardType.FieldsOfStudy">
			{{normalizedData.Name}} is found in a few different {{pages[0][0].Type}}s.
			Select the {{pages[0][0].Type}} below that you would like to
			<span *ngIf="targetType==='learnMore'">Learn More about:</span>
			<span *ngIf="targetType==='map'">view in Map:</span>
			<span *ngIf="targetType==='journey'">create a Journey:</span>
		</div>
	</div>
	<table class="w-100" style="color:#000; background-color:#fff;">
		<tr>
			<td class="jmCarousel">
				<!-- Carousel will not behave correctly when content size reduced, so need to flush the content -->
				<ng-container #outlet></ng-container>
				<ng-template #content>
					<ngb-carousel #myCarousel="ngbCarousel" appCarouselNoWrap
								  [ngClass]="{'h-100 w-100': !showMinimize}"
								  [ngStyle]="{'display':(showMinimize?'table-cell':'block')}">
						<ng-template ngbSlide *ngFor="let page of pages; let i=index;" id="{{i}}">
							<div [ngClass]="showMinimize?'row':'row h-100'">
								<div *ngFor="let item of page;" class="col-12 col-lg-4" [ngClass]="{'h-100': !showMinimize}" style="margin-bottom: 5px;">
									<div *ngIf="normalizedData.tCardType === tCardType.FieldsOfStudy" class="border" style="padding: 10px;" [ngStyle]="!showMinimize && {'height':'400px'}">
										<app-territory-card [normalizedData]="item" (onShowBackCard)="showBackCard($event)"></app-territory-card>
									</div>

									<div *ngIf="normalizedData.tCardType !== tCardType.FieldsOfStudy" class="border" [ngClass]="{'h-100': !showMinimize}" style="padding: 10px;">
										<!-- desktop view -->
										<div class="h-100" *ngIf="!showMinimize">
											<div>
												<div class="w-100 h-100" style="display: flex; position: relative;">
													<div style="flex: 0 1 100%;">
														<img appCardImgLazyLoad *ngIf="item.HeroImage!=null&&item.HeroImage!==''" [imgSrc]="item.HeroImage" class="territoryCardMediaImgShrinkHeight" style="width: 100%;" />
													</div>
												</div>
											</div>
											<div class="w-100" style="line-height: 25px;">
												<div class="territoryCardTitleText territoryCardTitleHeight"><span>{{item.Name}}</span></div>
											</div>
											<div class="w-100 text-center" style="padding-top: 5px;">
												<button type="button" class="btn btn-primary" (click)="select(item.Type, item.Id )">Select</button>
											</div>
										</div>
										<!-- mobile view -->
										<table *ngIf="showMinimize" [ngStyle]="{'color': ancestorIconForeground, 'background-color': ancestorIconBackground }" style="width: 100%; table-layout: fixed;">
											<tr>
												<td style="width: 80px;">
													<img appCardImgLazyLoad *ngIf="item.HeroImage!=null&&item.HeroImage!==''" [imgSrc]="item.HeroImage" style="width: 80px; height: 80px; max-height: 80px;" />
												</td>
												<td>
													<div style="padding-left: 10px;">
														<div id="territoryCardMobileTitle" class="territoryCardTitleText" style="overflow: hidden; text-overflow: ellipsis; font-size: 16px; height: 80px; line-height: 20px;">
															{{item.Name}}
														</div>
													</div>
												</td>
											</tr>
											<tr style="background-color: white;">
												<td colspan="2">
													<div class="w-100 text-center" style="padding-top: 5px;">
														<button type="button" class="btn btn-primary" (click)="select(item.Type, item.Id )">Select</button>
													</div>
												</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
						</ng-template>
					</ngb-carousel>
				</ng-template>
			</td>
		</tr>
	</table>
</div>
